import React from "react";

const OrderStatusDetailCardSkeleton = () => {
  return (
    <div className="rounded-[0.625rem] px-4 sm:px-9 py-6 border border-light-blue animate-pulse">
      <div className="w-32 h-6 bg-gray-200 rounded"></div>

      <hr className="h-[0.0625rem] bg-light-blue my-[0.625rem]" />
      <div>
        <div className="w-3/4 h-5 bg-gray-200 rounded"></div>
        {/* Task Details */}
        <div className="mt-6">
          {/* Mobile layout */}
          <div className="flex flex-col gap-2 sm:hidden">
            <div className="flex items-center justify-between">
              <div className="w-24 h-5 bg-gray-200 rounded"></div>
              <div className="w-24 h-5 bg-gray-200 rounded"></div>
            </div>
            <div className="flex items-center justify-between">
              <div className="w-24 h-5 bg-gray-200 rounded"></div>
              <div className="w-24 h-5 bg-gray-200 rounded"></div>
            </div>
          </div>

          {/* Desktop layout */}
          <div className="hidden sm:flex gap-[2.125rem]">
            <div className="flex flex-col gap-1">
              <div className="w-24 h-5 bg-gray-200 rounded"></div>
              <div className="w-24 h-5 bg-gray-200 rounded"></div>
            </div>
            <div className="flex flex-col gap-1">
              <div className="w-24 h-5 bg-gray-200 rounded"></div>
              <div className="w-24 h-5 bg-gray-200 rounded"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderStatusDetailCardSkeleton;
